import { slugger } from '../index'

const tagger = (tags, path) => {  
  return tags.map(tag => ({ label: tag, slug: slugger([tag]), path: `${path}${slugger([tag])}` }) )
}

export default tagger